import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import Loader from '../../../loader';
import { StripeForm } from '../StripeForm';
import { LoggedInPayment } from '../LoggedInPayment';
import { StripeInfo } from '../StripeInfo';
import { withLoadingFallback } from '../../../../hocs/withLoadingFallback';
import { LoginOptions } from '../LoginOptions';

const Container = styled.div`
  max-width: 508px;
  margin: 0 auto 24px;
`;

const ContainerWithLoadingFallback = withLoadingFallback(Container);

const PaymentScreenComponent = (props) => {
  const {
    user, isUserBusy, isPaymentFormShown, togglePaymentForm, setResult, setSent, schoolName, cost, schoolId, stripePromise, isMounted,
  } = props;

  return (
    <ContainerWithLoadingFallback isLoading={!isMounted || isUserBusy} fallback={<Loader containerHeight={350} />}>
      {
        isPaymentFormShown && (
          <StripeForm onClose={togglePaymentForm} setResult={setResult} setSent={setSent} schoolName={schoolName} cost={cost} stripePromise={stripePromise} />
        )
      }
      {
        !isEmpty(user)
          ? <LoggedInPayment togglePaymentForm={togglePaymentForm} cost={cost} />
          : <LoginOptions togglePaymentForm={togglePaymentForm} cost={cost} schoolId={schoolId} />
      }
      <StripeInfo />
    </ContainerWithLoadingFallback>
  );
};

PaymentScreenComponent.propTypes = {
  user: PropTypes.object.isRequired,
  isUserBusy: PropTypes.bool.isRequired,
  isPaymentFormShown: PropTypes.bool.isRequired,
  togglePaymentForm: PropTypes.func.isRequired,
  setResult: PropTypes.func.isRequired,
  setSent: PropTypes.func.isRequired,
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
  stripePromise: PropTypes.object,
  isMounted: PropTypes.bool,
};

PaymentScreenComponent.defaultProps = {
  stripePromise: null,
  isMounted: false,
};

export { PaymentScreenComponent };
